module.exports = __webpack_public_path__ + "static/media/financial.f8467c42.svg";